export const titleCase = (str: string) => {
  return str
    ?.toLowerCase()
    ?.split(' ')
    ?.map((word = '') => word.replace(word[0], word[0]?.toUpperCase()))
    ?.join(' ')
    ?.replace(/ And /g, ' and ');
};

export const camelCaseToTitleCase = (str: string) => {
  if (!str) return '';

  return (
    str[0].toUpperCase() +
    str
      .slice(1)
      .replace(/([A-Z])/g, ' $1')
      .trim()
  );
};
